import { Injectable } from '@angular/core'

import { Subject } from 'rxjs/Subject'
import { Subscription } from 'rxjs/Subscription'

import { config } from '../config/config'

@Injectable()
export class MessagesDelegate {

  private subject: Subject<Object>
  private labels: Object[]
  private lastMessage: Object

  constructor () {
    this.subject = new Subject<Object>()
    this.lastMessage = {}

    this.labels = [
      {
        code: 'ERROR.UNKNOWN',
        title: "Une erreur d'origine inconnue est survenue",
        level: 'warning'
      },
      {
        code: 'USER.LOGIN.WRONG_CREDENTIALS',
        title: 'Email ou mot de passe incorrect',
        level: 'warning'
      },
      {
        code: 'USER.AVATAR.UPLOAD_FAILED',
        title: "Echec de l'enregistrement de l'avatar",
        text: '',
        level: 'warning'
      },
      {
        code: 'EVENT.PICTURE.UPLOAD_FAILED',
        title: "Echec de l'enregistrement du fichier",
        text: '',
        level: 'warning'
      },
      {
        code: 'USER.AUTH.WRONG_PASSWORD',
        title: 'Mot de passe incorrect',
        level: 'warning'
      },
      {
        code: 'AUTH.INVALID_TOKEN',
        title: 'Erreur de connexion',
        text: 'Merci de vous reconnecter',
        level: 'warning'
      },
      {
        code: 'APP.IMAGE.OVERSIZED',
        title: `L'une des images dépasse ${config.images.maxSize / 1048576}Mo et sera refusée au téléchargement`,
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.USERSLIST.ERROR',
        title: 'Erreur lors du chargement des membres',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.EVENTSLIST.ERROR',
        title: 'Erreur lors du chargement des événements',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.EVENT.NOT_FOUND',
        title: 'Evénement introuvable',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.EVENT.DELETED',
        title: 'Evénement supprimé',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.LOGOUT.ERROR',
        title: 'Erreur lors de la déconnexion',
        text: '',
        level: 'warning'
      },
      {
        code: 'AUTH.SESSION_EXPIRED',
        title: 'Votre session a expirée',
        text: 'Merci de vous reconnecter',
        level: 'warning'
      },
      {
        code: 'CLIENT.MISSING_PARAMETERS',
        title: 'Erreur serveur: paramètres manquants',
        text: '',
        level: 'warning'
      },
      {
        code: 'CLIENT.FORBIDDEN',
        title: 'Vous n\`êtes pas autorisé à accéder à cette ressource',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.INVALID_FORM',
        title: 'Le formulaire comporte des erreurs',
        text: '',
        level: 'warning'
      },
      {
        code: 'USER.EMAIL_ALREADY_EXISTS',
        title: "L'email a déjà été pris par un autre membre",
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.USER.NOT_FOUND',
        title: 'Membre non trouvé',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.USER.CREATED',
        title: 'Membre enregistré',
        text: '',
        level: 'info'
      },
      {
        code: 'APP.USER.DELETED',
        title: 'Membre supprimé',
        text: '',
        level: 'info'
      },
      {
        code: 'APP.EVENT.CREATED',
        title: 'Evénement enregistré',
        text: '',
        level: 'info'
      },
      {
        code: 'APP.EVENT.UPDATED',
        title: 'Evénement mis à jour',
        text: '',
        level: 'info'
      },
      {
        code: 'APP.USER.UPDATED',
        title: 'Les modifications ont été enregistrées',
        text: '',
        level: 'info'
      },
      {
        code: 'APP.RELATIONSHIP.USER_LIMIT_EXCEEDED',
        title: 'Une seule relation avec un autre membre',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.RELATIONSHIP.PARENT_LIMIT_EXCEEDED',
        title: 'Un membre ne peut avoir plus de deux parents',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.GROUPLIST.ERROR',
        title: 'Erreur lors du chargement des groupes',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.GROUP.NOT_FOUND',
        title: 'Groupe non trouvé',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.GROUP.UPDATED',
        title: 'Groupe modifié',
        text: '',
        level: 'warning'
      },
      {
        code: 'APP.GROUP.JOINED',
        title: 'Vous avez rejoint le groupe',
        text: '',
        level: 'infos'
      },
      {
        code: 'APP.GROUP.LEAVED',
        title: 'Vous avez quitté le groupe',
        text: '',
        level: 'infos'
      },
      {
        code: 'APP.GROUP.DELETED',
        title: 'Le groupe a été supprimé',
        text: '',
        level: 'infos'
      }
    ]

    this.add = this.add.bind(this)
    this.last = this.last.bind(this)
    this.subscribe = this.subscribe.bind(this)
  }

  add (msgCode: string = 'ERROR.UNKNOWN', persist: boolean = false) {
    let msg = this.labels.find(el => el['code'] === msgCode)

    // only show whitelisted messages
    if (!msg || !msg['code']) return

    this.lastMessage = persist ? msg : {}

    this.subject.next(msg)
  }

  last () {
    const send = this.lastMessage
    this.lastMessage = {}
    return send
  }

  subscribe (fn): Subscription {
    return this.subject.asObservable().subscribe(fn)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/messages-delegate.service.ts